document.addEventListener("DOMContentLoaded", function () {
  const buttonModal = document.createElement("button");
  buttonModal.id = "openModal";
  //buttonModal.textContent = "Size chart";
  buttonModal.innerHTML =
    'Size Chart <img src="https://cdn.shopify.com/s/files/1/2527/6546/files/img_442006.png?v=1697574031" >';

  // Find the existing element with class .wairButtonContainer
  const existingContainer = document.querySelector(".wairButtonContainer");

  // Append the button to the existing container
  existingContainer.appendChild(buttonModal);

  /*
  const openModalButton = document.getElementById("openModal");
  const modal = document.getElementById("myModal");
  const closeModalButton = document.getElementById("closeModal");

  openModalButton.addEventListener("click", () => {
    modal.style.display = "block";
  });

  closeModalButton.addEventListener("click", () => {
    modal.style.display = "none";
  });

  window.addEventListener("click", (event) => {
    if (event.target === modal) {
      modal.style.display = "none";
    }
  });
  */
  /*var triggerElement = document.querySelector(
    "#shopify-block-89359631-26a5-4f16-8f7c-67c583012071"
  );
  

  var titleT = document.querySelector(".product__title");

 
   document
    .getElementById("toggle-button")
    .addEventListener("click", function () {
      const measurementTypeSelect = document.getElementById("measurement-type");
      const measurementType = document.getElementById("measurement-type").value;
      const items = document.querySelectorAll(".number-to-convert");
      const toggleButton = document.getElementById("toggle-button");

      for (const item of items) {
        if (item.hasAttribute("data-original-value")) {
          const originalValue = item.getAttribute("data-original-value");
          item.textContent = originalValue;
          item.removeAttribute("data-original-value");
        } else {
          const originalValue = item.textContent;

          if (originalValue.includes("-")) {
            const values = originalValue.split("-").map((value) => {
              return measurementType === "centimeters"
                ? (value * 0.393701).toFixed(2)
                : (value * 2.54).toFixed(2);
            });
            item.textContent = values.join(" - ");
          } else if (!isNaN(originalValue)) {
            const convertedValue =
              measurementType === "centimeters"
                ? (originalValue * 0.393701).toFixed(2)
                : (originalValue * 2.54).toFixed(2);
            item.textContent = convertedValue;
          }

          item.setAttribute("data-original-value", originalValue);
        }
      }
      if (measurementType === "inches") {
        measurementTypeSelect.value = "centimeters";
        toggleButton.textContent = "Convert to Inches";
      } else {
        measurementTypeSelect.value = "inches";
        toggleButton.textContent = "Convert to CM";
      }
    }); */
});
